import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { ImagenApi } from '../models/api/auth-api';
import { ResponseApi } from '../models/response-api';
import { AppUtil } from '../utility/app-util';

@Injectable({ providedIn: 'root' })
export class ImagenService {
    private http = inject(HttpClient);
    private url = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/imagen/';

    upload(files: File[]): Observable<ImagenApi[]> {
        if (!files.length) {
            return of([]);
        }

        const form = new FormData();
        for (const file of files) {
            form.append('files', file, file.name);
        }

        return this.http.post<ResponseApi<ImagenApi[]>>(this.url + 'upload-imagenes', form).pipe(
            map((res) => {
                if (res.success !== Constante.REQUEST_STATUS_OK || !Array.isArray(res.data) || res.data.length === 0) {
                    const errors = res.errors as { message?: string }[] | null;
                    throw new Error(errors?.[0]?.message || res.message || 'No se pudieron subir las fotos.');
                }
                if (res.data.length !== files.length) {
                    throw new Error('Algunas fotos no se aceptaron. Usa JPEG, PNG o WebP.');
                }
                return res.data;
            })
        );
    }
}
